import { Presets, StoredFilter } from '../models/filter-models';
import { WeaponType } from '../models/enums';
import { collectMyGearWeaponClasses, resolvePreferredWeaponClass } from './gear-preferred-weapon';
import { poe1 } from '../../game';

export type ActiveFilterIcons =
  | { mode: 'custom'; icons: [string] }
  | { mode: 'auto'; icons: string[] };

// Curated allowlist for the custom-icon picker (icomoon names without `icon-` prefix).
export const ACTIVE_FILTER_ICON_ALLOWLIST: readonly string[] = [
  'bow',
  'claw',
  'crossbow',
  'dagger',
  'onehandaxe',
  'onehandmace',
  'onehandsword',
  'rapier',
  'scepter',
  'staff',
  'talisman',
  'twohandaxe',
  'twohandmace',
  'twohandsword',
  'wand',
  'str',
  'dex',
  'int',
  'strdex',
  'strint',
  'dexint',
  'campaign-1',
  'campaign-2',
  'campaign-3',
  'endgame-1',
  'endgame-2',
  'endgame-3',
  'endgame-4',
  'star-1',
  'star-2',
  'star-3',
  'star-4',
  'star-5',
  'trophy',
  'shield',
  'target',
  'magic-wand',
  'filter',
  'tutor',
  'good-mod',
  'great-mod',
  'perfect-mod',
  'lab',
  'power',
  'heart',
  'price-tag'
];

export const WEAPON_TYPE_ICON_MAP: Readonly<Record<string, string>> = {
  [WeaponType.Bows]: 'bow',
  [WeaponType.Claws]: 'claw',
  [WeaponType.Crossbows]: 'crossbow',
  [WeaponType.Daggers]: 'dagger',
  [WeaponType.Foci]: 'wand',
  [WeaponType.OneHandSwords]: 'onehandsword',
  [WeaponType.OneHandAxes]: 'onehandaxe',
  [WeaponType.OneHandMaces]: 'onehandmace',
  [WeaponType.Quivers]: 'bow',
  [WeaponType.Quarterstaves]: 'staff',
  [WeaponType.RuneDaggers]: 'dagger',
  [WeaponType.Sceptres]: 'scepter',
  [WeaponType.Spears]: 'wand',
  [WeaponType.Talismans]: 'talisman',
  [WeaponType.Staves]: 'staff',
  [WeaponType.ThrustingOneHandSwords]: 'rapier',
  [WeaponType.TwoHandAxes]: 'twohandaxe',
  [WeaponType.TwoHandMaces]: 'twohandmace',
  [WeaponType.TwoHandSwords]: 'twohandsword',
  [WeaponType.Wands]: 'wand',
  [WeaponType.Warstaves]: 'staff',
};

export const PROGRESS_PRESET_ICON_MAP: Readonly<Partial<Record<Presets, string>>> = {
  presetEarlyCampaign1: 'campaign-1',
  presetMidCampaign30: 'campaign-2',
  presetLateCampaignEarlyMaps60: poe1 ? 'campaign-3' : 'campaign-2',
  presetMidMaps70: 'endgame-1',
  presetEndGame80: 'endgame-2',
  presetStrict90: 'endgame-3',
  presetVeryStrict95: 'endgame-4',
};

export function resolveActiveFilterIcons(stored: StoredFilter, allWeaponClasses: string[]): ActiveFilterIcons {
  if (stored.icon) {
    return { mode: 'custom', icons: [stored.icon] };
  }

  const icons: string[] = [];

  const progress = stored.filter.progressPreset;
  if (progress) {
    const progressIcon = PROGRESS_PRESET_ICON_MAP[progress];
    if (progressIcon) icons.push(progressIcon);
  }

  const myGear = collectMyGearWeaponClasses(stored.filter, allWeaponClasses);
  const available = myGear ? [...myGear] : allWeaponClasses;
  const preferredWeapon = resolvePreferredWeaponClass(stored.filter, available);
  if (preferredWeapon) {
    const weaponIcon = WEAPON_TYPE_ICON_MAP[preferredWeapon];
    if (weaponIcon) icons.push(weaponIcon);
  }

  return { mode: 'auto', icons };
}

export function iconClass(name: string): string {
  return `icon icon-${name}`;
}
